import { CompanyUserCreatePage } from "@/features/company/pages/company-user/CompanyUserCreate";
import React from "react";

const CompanyUserCreate = () => {
  return <CompanyUserCreatePage />;
};

export default CompanyUserCreate;
